import React from 'react'
import { Link } from 'react-router-dom'
import Hero from './hero'
import Banner from './banner'
function ErrorPage() {
    return (
       <Hero>
           <Banner title='404' subtitle='Page Not Found'>
               <Link to='/' className='btn-primary'>
                   Return Home
               </Link>
           </Banner>
       </Hero>
    )
}

export default ErrorPage
